import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  ComponentLayout,
  React
};